import { gql } from 'graphql-request'

export const REMOVE_BOOK_COLLECTION = gql`
  mutation RemoveBookCollection($removeBookCollectionId: Int!) {
    removeBookCollection(id: $removeBookCollectionId) {
      id
    }
  }
`
